import { render, staticRenderFns } from "./LoanForm.vue?vue&type=template&id=21e04b9e&scoped=true"
import script from "./LoanForm.vue?vue&type=script&lang=js"
export * from "./LoanForm.vue?vue&type=script&lang=js"
import style0 from "./LoanForm.vue?vue&type=style&index=0&id=21e04b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e04b9e",
  null
  
)

export default component.exports